import "./src/css/style.css";

// Load Inter typeface
require("typeface-inter");
